<template>
  <div class="max-w-3xl mx-auto text-center">
    <h1 class="text-2xl font-bold">Let's dig a little deeper on your team.</h1>
    <p class="text-lg mb-4">Help us understand your team's structure and growth plans.</p>
    <FormKit type="form" @submit="$emit('next')" class="mt-8" v-model="formData" :actions="false">
      <FormKit
        type="select"
        name="numberOfAgents"
        label="How many agents do you currently have?"
        :options="['1-5', '6-10', '11-20', '21-50', '50+']"
        placeholder="Select amount"
      />
      <FormKit
        type="select"
        name="agentGrowthOverNextYear"
        label="How many agents do you want to hire over the next year?"
        :options="['1-5', '6-10', '11-20', '21-50', '50+']"
        placeholder="Select amount"
      />
      <FormKit
        :options="['Recruiter', 'Sales Manager', 'Office Manager', 'Transaction Coordinator', 'Other']"
        type="checkbox"
        label="What support roles does your team have?"
        name="supportRoles"
      />
      <FormKit
        :options="['Leads', 'Initial Agent Training', 'Ongoing Training', 'Other']"
        type="checkbox"
        label="What other ways do you provide value to your team?"
        name="otherValueAdds"
      />
      <FormKit type="submit" label="Continue" class="btn btn-primary" />
    </FormKit>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    companyTypes() {
      return 'agents';
    },
    formData: {
      set(newData) {
        this.$store.commit('onboarding/setTeam', newData);
      },
      get() {
        return this.team;
      },
    },
    ...mapState({
      team: state => state.onboarding.team,
    }),
  },
};
</script>

<style></style>
